import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import AutoNurture from '../components/Frontend/AutoNurture/tabComps/AutoNurture';
import { AccountListProvider } from '../context/AccountListContext';

export const autoNurtureRoutes = (
  <Route path="/auto_nurture" element={<MainLayout />}>
    <Route path="" element={<div className='meeting-preps-container' 
      style={{
        backgroundColor: "#FFF",
        maxWidth: "100%",
        margin: "10px",
        borderRadius: "12px",
        minHeight: "100vh",
        boxShadow: "0px 0px 14px 0px #8B50CF1F",
        border: "1px solid #98A4AA4D",
        // padding: "13px",
      }}
     >
      <AccountListProvider> <AutoNurture /></AccountListProvider>
     </div> } />
  </Route>
);
